import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PromotionBanner } from '@barkinglabs/promotions-react';
import { PromotionConfigurationKind } from '@barkinglabs/promotions-types';
import styles from './QuizPromotionBanner.module.scss';
import * as events from '../../lib/analytics/events';
import { QuizReferral } from '../../lib/quizReferral';

interface QuizPromotionBannerProps {
  referral: QuizReferral;
  couponCode?: string;
  onClick?: () => void;
  onDismiss: () => void;
}

/**
 * The quiz-referred variant of the shop promo banner: same PromotionBanner
 * component the coupon promotions render through (see NanoBannerV2), fed
 * personalized copy instead of the fi-admin promotion text.
 */
export default function QuizPromotionBanner({ referral, couponCode, onClick, onDismiss }: QuizPromotionBannerProps) {
  const { t } = useTranslation();

  useEffect(() => {
    events.quizPdpBannerShown();
  }, []);

  const title = referral.petName
    ? t('quiz_picked_for_pet_name', { petName: referral.petName })
    : referral.species === 'cat'
      ? t('quiz_picked_for_your_cat')
      : t('quiz_picked_for_your_dog');

  const subtitle = referral.breed
    ? t('quiz_banner_reason_with_breed', { breed: referral.breed })
    : t('quiz_banner_reason');

  return (
    <div className={styles.container} data-testid="quiz-promo-banner">
      <div onClick={onClick}>
        <PromotionBanner
          className={'promotionBanner'}
          promotion={{
            configuration: {
              kind: PromotionConfigurationKind.SIMPLE,
              title,
              subtitle,
              couponCode,
              countdown: 'none',
              extraCss: undefined,
              imageUrl: undefined,
              backgroundImageUrl: undefined,
            },
          }}
          promotionEnd={''}
        />
      </div>
      <button
        type="button"
        className={styles.dismissButton}
        aria-label={t('dismiss')}
        data-testid="quiz-promo-banner-dismiss"
        onClick={(e) => {
          e.stopPropagation();
          onDismiss();
          events.quizPdpBannerDismissed();
        }}
      >
        <span className={styles.dismissIcon} />
      </button>
    </div>
  );
}
